const getProductByHandle = async (productHandle) => {
  try {
    const response = await fetch(`/products/${productHandle}?view=json`);
    if (!response.ok) {
      throw new Error(`Failed to fetch product: ${response.status} ${response.statusText}`);
    }
    return await response.json();
  } catch (error) {
    throw new Error('Failed to fetch product. Please try again later.');
  }
};

const getVariantCountString = (product) => {
  if (product.variants && product.variants.length > 1) {
    const productTags = product.tags.map(tag => tag.toLowerCase()).join(' ');
    const productType = (product.product_type || '').toLowerCase();

    if (productTags.includes('apparel') || productType.includes('apparel')) {
      return `${product.variants.length} Sizes`;
    } else if (product.handle.includes('shaker')) {
      return `${product.variants.length} Colors`;
    } else {
      return `${product.variants.length} Flavors`;
    }
  }
  return '';
};

const getProductBadges = (product) => {
  const badges = [];

  if (!product.available) {
    badges.push({ class: 'product-badge inventory product-badge--sold-out', text: 'SOLD OUT' });
  }

  if (product.tags && product.tags.length > 0) {
    product.tags.forEach(tag => {
      const tagHandle = tag.toLowerCase().replace(/\s+/g, '-');

      if (tagHandle === 'new') {
        badges.push({ class: 'product-badge meta product-badge--new-product', text: 'NEW' });
      } else if (tagHandle === 'best-seller') {
        badges.push({ class: 'product-badge meta product-badge--best-seller', text: 'BEST SELLER' });
      } else if (tagHandle === 'new-flavor') {
        badges.push({ class: 'product-badge meta product-badge--new-flavor', text: 'NEW FLAVOR' });
      }
    });
  }

  return badges;
};

const formatMoney = (cents) => {
  if (!cents) return '$0.00';
  const dollars = cents / 100;
  return `$${dollars.toFixed(2)}`;
};

const renderProductTile = (product) => {
  const variantCountString = getVariantCountString(product);
  const badges = getProductBadges(product);
  const onSale = product.compare_at_price_min > product.price_min;

  let priceHtml = '';

  if (product.available) {
    if (product.variants && product.variants.length > 1 && product.price_varies) {
      priceHtml = `<span class="price"><span class="money">${formatMoney(product.price_min)}</span></span>`;
    } else {
      if (onSale) {
        priceHtml = `
          <span class="price on-sale">
            <span class="money">${formatMoney(product.price)}</span>
            <span class="original money">${formatMoney(product.compare_at_price)}</span>
          </span>
        `;
      } else {
        priceHtml = `<span class="price money">${formatMoney(product.price)}</span>`;
      }
    }
  } else {
    priceHtml = '<span class="price">Sold Out</span>';
  }

  let badgesHtml = '';
  if (badges.length > 0) {
    badgesHtml = `
      <div class="product-badge__wrapper">
        ${badges.map(badge => `<span class="${badge.class}">${badge.text}</span>`).join('')}
      </div>
    `;
  }

  const featuredImage = product.featured_image || {};
  const imageUrl = featuredImage.src || '';
  const imageAlt = featuredImage.alt || product.title;

  return `
    <div class="bundle-product">
      ${badgesHtml}
      <figure class="product-list-item-thumbnail">
        <a href="${product.url || '#'}">
          <img class="only-image lazyload" src="${imageUrl}" alt="${imageAlt}" />
        </a>
      </figure>
      <!-- qty count -->
      <div class="qty-count" data-product-handle="${product.handle}">
        <span></span>
      </div>

      <div class="product-list-item-details">
        <div class="details-bottom">
          <span class="number-of-variants">${variantCountString}</span>
          <h3 class="product-list-item-title">
            <a href="${product.url || '#'}">${product.title}</a>
          </h3>

          <p class="product-list-item-price">
            ${priceHtml}
          </p>
        </div>

        <div class="details-top">
          <div class="yotpo bottomLine" data-product-id="${product.id}"></div>
        </div>

        <button class="btn display-on-hover" select-flavors product-id="${product.id}" product-handle="${product.handle}" data-bundle="true">
          Select Flavors
        </button>
      </div>
    </div>
  `;
};

document.addEventListener('DOMContentLoaded', function () {
  // get all divs with data-bundle-product-tile attribute
  const bundleProductTiles = document.querySelectorAll('div[data-bundle-product-tile]');
  let loadedCount = 0;
  const totalTiles = bundleProductTiles.length;

  bundleProductTiles.forEach(tile => {
    const productHandle = tile.getAttribute('data-bundle-product-handle');
    getProductByHandle(productHandle)
      .then(response => {
        const product = response;
        if (product) {
          const productHtml = renderProductTile(product);
          tile.innerHTML = productHtml;
        }
        loadedCount++;
        if (loadedCount === totalTiles) {
          // All tiles have been loaded, trigger custom event
          const event = new CustomEvent('BundleTilesLoaded', {
            detail: { tiles: bundleProductTiles }
          });
          document.dispatchEvent(event);
          window.yotpoWidgetsContainer.initWidgets();
          const removeReviewFromYotpo = () => {
            const reviewsCounters = document.querySelectorAll('.yotpo.bottomLine a.text-m');
            if (reviewsCounters && reviewsCounters.length) {
              reviewsCounters.forEach(counter => {
                const text = counter.innerHTML.split(' ');
                counter.innerHTML = text[0];
              });
            } else {
              setTimeout(removeReviewFromYotpo, 100);
            }
          }
          removeReviewFromYotpo();
        }
      })
      .catch(error => {
        console.error('Error fetching product:', error);
        loadedCount++;
        if (loadedCount === totalTiles) {
          // All tiles have been processed (even if some failed)
          const event = new CustomEvent('BundleTilesLoaded', {
            detail: { tiles: bundleProductTiles }
          });
          document.dispatchEvent(event);
          window.yotpoWidgetsContainer.initWidgets();
        }
      });
  });
});
